import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { ApiService } from "./utilities/api.service";

@Injectable()
export class TagService {
  constructor(private apiService: ApiService) {}

  public getDiscussionsTags(): Observable<[string]> {
    return this.apiService
      .get("/tags/discussions")
      .pipe(map((data) => data.tags));
  }

  public getCommunitiesTags(): Observable<[string]> {
    return this.apiService
      .get("/tags/communities")
      .pipe(map((data) => data.tags));
  }
}
